(function () {
  'use strict';


  /*
   * ==========================================================
   * FIND ALL SECTIONS
   * ==========================================================
   */

  const sections = document.querySelectorAll(
    '.ingredient-story-grid[data-section-id]'
  );

  if (!sections.length) return;


  sections.forEach(function (section) {


    /*
     * ========================================================
     * TAB ELEMENTS
     * ========================================================
     */

    const tabs = section.querySelectorAll(
      '[data-ingredient-tab]'
    );

    const panels = section.querySelectorAll(
      '[data-ingredient-panel]'
    );


    /*
     * ========================================================
     * CLOSE OPEN INGREDIENT
     * ========================================================
     */

    function closeIngredient(item) {

      if (!item) return;


      const toggle = item.querySelector(
        '[data-ingredient-toggle]'
      );

      const details = item.querySelector(
        '[data-ingredient-details]'
      );


      item.classList.remove('is-open');


      if (toggle) {
        toggle.setAttribute(
          'aria-expanded',
          'false'
        );
      }


      if (details) {
        details.classList.remove('is-open');

        details.setAttribute(
          'hidden',
          ''
        );
      }

    }


    /*
     * ========================================================
     * OPEN INGREDIENT
     * ========================================================
     */

    function openIngredient(item) {

      if (!item) return;


      const toggle = item.querySelector(
        '[data-ingredient-toggle]'
      );

      const details = item.querySelector(
        '[data-ingredient-details]'
      );


      if (!details) return;


      item.classList.add('is-open');


      if (toggle) {
        toggle.setAttribute(
          'aria-expanded',
          'true'
        );
      }


      /*
       * Remove hidden before animation.
       */

      details.removeAttribute('hidden');


      /*
       * Force browser to register initial state.
       */

      requestAnimationFrame(function () {

        details.classList.add('is-open');

      });

    }


    /*
     * ========================================================
     * TOGGLE INGREDIENT
     * ========================================================
     */

    function toggleIngredient(item) {

      if (!item) return;


      const isOpen =
        item.classList.contains('is-open');


      /*
       * Close every ingredient in this section.
       */

      const allItems =
        section.querySelectorAll(
          '[data-ingredient-item]'
        );


      allItems.forEach(function (otherItem) {

        if (otherItem !== item) {
          closeIngredient(otherItem);
        }

      });


      /*
       * Toggle clicked ingredient.
       */

      if (isOpen) {

        closeIngredient(item);

      } else {

        openIngredient(item);

      }

    }


    /*
     * ========================================================
     * INGREDIENT BUTTONS
     * ========================================================
     */

    const toggles = section.querySelectorAll(
      '[data-ingredient-toggle]'
    );


    toggles.forEach(function (toggle) {

      toggle.addEventListener(
        'click',
        function (event) {

          event.preventDefault();
          event.stopPropagation();


          const item =
            toggle.closest(
              '[data-ingredient-item]'
            );


          toggleIngredient(item);

        }
      );

    });


    /*
     * ========================================================
     * TAB SWITCHING
     * ========================================================
     */

    function activateTab(tabName) {


      /*
       * Update tab buttons.
       */

      tabs.forEach(function (tab) {

        const active =
          tab.dataset.ingredientTab === tabName;


        tab.classList.toggle(
          'is-active',
          active
        );


        tab.setAttribute(
          'aria-selected',
          active ? 'true' : 'false'
        );

      });


      /*
       * Update panels.
       */

      panels.forEach(function (panel) {

        const active =
          panel.dataset.ingredientPanel === tabName;


        panel.classList.toggle(
          'is-active',
          active
        );


        if (active) {

          panel.removeAttribute('hidden');

        } else {

          panel.setAttribute('hidden', '');

        }

      });


      /*
       * Close any previously opened ingredient
       * when switching tabs.
       */

      section
        .querySelectorAll(
          '[data-ingredient-item].is-open'
        )
        .forEach(function (item) {

          closeIngredient(item);

        });

    }


    /*
     * ========================================================
     * TAB CLICK EVENTS
     * ========================================================
     */

    tabs.forEach(function (tab) {

      tab.addEventListener(
        'click',
        function () {

          activateTab(
            tab.dataset.ingredientTab
          );

        }
      );

    });


    /*
     * ========================================================
     * INITIAL STATE
     * ========================================================
     */

    // const firstPanel =
    //   section.querySelector(
    //     '[data-ingredient-panel="science"]'
    //   );


    // if (firstPanel) {

    //   firstPanel
    //     .querySelectorAll(
    //       '[data-ingredient-item]'
    //     )
    //     .forEach(function (item) {

    //       closeIngredient(item);

    //     });

    // }
    /*
 * ========================================================
 * INITIAL STATE
 * ========================================================
 */

const activeTab =
  section.querySelector(
    '[data-ingredient-tab].is-active'
  );

if (activeTab) {

  activateTab(
    activeTab.dataset.ingredientTab
  );

}


  });

})();